export type ErrorPayload = { error?: { code?: string; message?: string; fieldErrors?: unknown }; message?: string; requestId?: string };

export function errorMessage(payload: ErrorPayload, status: number): string {
  const fallback = status === 502 || status === 503
    ? '服务连接暂时中断，请先刷新确认业务状态后再操作'
    : `请求失败（${status}）`;
  const message = payload.error?.message ?? payload.message ?? fallback;
  return payload.requestId ? `${message}（请求号：${payload.requestId}）` : message;
}

export function needsIdempotency(method = 'GET', path = ''): boolean {
  return !['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase()) && !path.startsWith('/auth/');
}
